import * as React from 'react';
import Stack from '@mui/material/Stack';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CustomDatePicker from './CustomDatePicker';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';

import Search from './Search';

export default function Header() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const notifications = []; // TODO: connect to backend notifications endpoint

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs />
      <Stack direction="row" sx={{ gap: 1 }}>
        <Search />
        <CustomDatePicker />
        <MenuButton
          showBadge={notifications.length > 0}
          aria-label="Open notifications"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <NotificationsRoundedIcon />
        </MenuButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          slotProps={{ paper: { sx: { minWidth: 280 } } }}
        >
          {notifications.length === 0 ? (
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                未読通知はありません
              </Typography>
            </MenuItem>
          ) : (
            notifications.map((n) => (
              <MenuItem key={n.id} onClick={() => setAnchorEl(null)}>
                <Typography variant="body2">{n.message}</Typography>
              </MenuItem>
            ))
          )}
        </Menu>
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
